import api from '../../../data/api';
import { ProducePopups } from './components/ProducePopup';

const AddPopups = () => {
	const handleSubmit = async (popupData, token) => {
		// Submit the API request
		return await api.createPopupApi(popupData, token);
	};

	return <ProducePopups onSubmit={handleSubmit} />;
};

export default AddPopups;
